import styled from 'styled-components'
import { Pencil } from '@styled-icons/boxicons-regular'
import { ChatRightTextFill } from '@styled-icons/bootstrap'

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`

const Button = styled.button`
  border-radius: 8px;
  color: white;
  font-family: Work Sans;
  line-height: 19px;
  font-weight: bold;
  padding: 0.3rem 0.5rem;
  font-size: 14px;
  border: 0;
  margin-left: 12px;
  margin-right: 12px;
  padding-left: 12px;
  padding-right: 12px;
`

export const CancelButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.red};
`

export const ConfirmButton = styled(Button)`
  background-color: ${({ disabled, theme }) => (disabled ? '#bbbbbb' : theme.colors.blue)};
`
export const PencilStyled = styled(Pencil)`
  color: white;
  width: 26px;
  height: 26px;
`

export const BodyContainer = styled.div`
  padding: 24px;
`

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const ChatRightTextFillFillStyled = styled(ChatRightTextFill)`
  color: ${({ theme }) => theme.colors.gray3};
  margin-right: 8px;
  width: 24px;
  height: 24px;
`

export const DescriptionText = styled.label`
  font-size: 0.9rem;
  padding: 0 1rem;
`

export const DescriptionBold = styled.label`
  font-size: 0.9rem;
  font-weight: bold;
  line-height: 0.1;
`

export const DescriptionTextContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const InputContainer = styled.div`
  margin: 1rem;
`

export const Input = styled.textarea`
  width: 100%;
  box-sizing: border-box;
  border-radius: 0.5rem;
  border: 0;
  padding: 0.5rem;
  font-family: Work Sans;
  font-style: normal;
  font-weight: 400;
  font-size: 0.9rem;
  outline: 0;
  resize: none;
  box-shadow: 2px 2px 6px gray;
`

export const CharactersRemainingContainer = styled.label`
  display: flex;
  justify-content: end;
`

export const CharactersRemainingText = styled.label`
  font-size: 0.6rem;
`
